import _ from "lodash";

export default {
    getNotifications: (state) => state.notifications,
    getUnreadNotificationCount: (state) => _.reduce(state.notifications, function(sum, notification) { return +(!notification.read_at) + sum; }, 0),
}
